<template>
  <div class="collaborate-container" :class="{'collaborate-container-ai': getInterestGroup.length > 0 && topic.interest.interest !== 'Your PDB'}">
    <div class="collaborate-container__header">
      <div class="collaborate-container__header--left">
        <div v-if="getInterestGroup.length > 0 && topic.interest.interest !== 'Your PDB'" class="collaborate-container__header--left--topic-title">
            <svg
              v-if="!topic?.interest?.is_private"
              xmlns="http://www.w3.org/2000/svg"
              height="48"
              viewBox="0 96 960 960"
              width="48"
              >
                <path
                  d="M480 976q-83 0-156-31.5T197 859q-54-54-85.5-127T80 576q0-83 31.5-156T197 293q54-54 127-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 83-31.5 156T763 859q-54 54-127 85.5T480 976Zm-43-61v-82q-35 0-59-26t-24-61v-44L149 497q-5 20-7 39.5t-2 39.5q0 130 84.5 227T437 915Zm294-108q22-24 38.5-51t28-56.5q11.5-29.5 17-60.5t5.5-63q0-106-58-192.5T607 257v18q0 35-24 61t-59 26h-87v87q0 17-13.5 28T393 488h-83v88h258q17 0 28 13t11 30v127h43q29 0 51 17t30 44Z"
                />
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              height="48"
              viewBox="0 96 960 960"
              width="48"
            >
              <path
                d="M220 976q-24.75 0-42.375-17.625T160 916V482q0-24.75 17.625-42.375T220 422h70v-96q0-78.85 55.606-134.425Q401.212 136 480.106 136T614.5 191.575Q670 247.15 670 326v96h70q24.75 0 42.375 17.625T800 482v434q0 24.75-17.625 42.375T740 976H220Zm260.168-200Q512 776 534.5 753.969T557 701q0-30-22.668-54.5t-54.5-24.5Q448 622 425.5 646.5t-22.5 55q0 30.5 22.668 52.5t54.5 22ZM350 422h260v-96q0-54.167-37.882-92.083-37.883-37.917-92-37.917Q426 196 388 233.917 350 271.833 350 326v96Z"
              />
            </svg>
            <h1>
              {{ topic?.interest?.is_private ? 'Private' : 'Public' }}
            </h1>
        </div>
        <h1 class="collaborate-container__header--left--title">
          {{collaborateTitle}}
        </h1>
      </div>
      <div class="collaborate-container__header--right">
        <a-tooltip placement="bottom">
          <template #title>Search</template>
            <button class="collaborate-container__header--right--btn" @click="toggleSearch">
              <img src="@/assets/icons/search-icon.svg" alt="Icon" />
            </button>
        </a-tooltip>
        <a-tooltip v-if="showInviteButton" placement="bottom">
          <template #title>Invite</template>
          <button class="collaborate-container__header--right--btn group-icon-btn" @click="visibleInvitationCategory()">
            <img src="@/assets/icons/add-group-icon.svg" alt="Icon" />
          </button>
        </a-tooltip>
        <a-tooltip v-if="showSeeAllContibutorsButton" placement="bottom">
          <template #title>All collaborators</template>
          <button class="collaborate-container__header--right--btn group-icon-btn" @click="openAllUsersModal(activeTab)" style="margin-right: -0.5rem;">
            <img src="@/assets/icons/group-icon.svg" alt="Icon" />
          </button>
        </a-tooltip>
        <a-tooltip v-if="showDateRageButton" placement="bottom">
          <template #title>Date Range</template>
          <button class="collaborate-container__header--right--btn" @click="showDatePicker">
            <img src="@/assets/icons/calendar-icon.svg" alt="Icon" />
            <a-range-picker
              status="warning"
              :ranges="{
                Today: [moment(), moment()],
                'Week': [moment().subtract(6, 'days'), moment()],
                'Month': [moment().subtract(30, 'days'), moment()],
              }"
              style="width: 100%;"
              :open="isDatePickerVisible"
              @change="handleDateChange"
              ref="publicDateRangePicker"
            >
            <template #renderExtraFooter >
              <div class="footer-container">
                <span
                  type="primary"
                  @click="applyFilter"
                  class="ant-tag ant-tag-blue apply-filter-button"
                >
                  Apply Filters
                </span>
              </div>
            </template>     
            </a-range-picker>
          </button>
        </a-tooltip>
        <a-tooltip v-if="showHistoryButton" placement="bottom">
          <template #title>History</template>
          <button class="collaborate-container__header--right--btn" @click="openCollaboratePreviousSearchesDrawer()">
            <img src="@/assets/icons/history-icon.svg" alt="Icon" />
          </button>
        </a-tooltip>
        <a-tooltip v-if="showNewInquiryButton" placement="bottom">
          <template #title>New inquiry</template>
          <button class="collaborate-container__header--right--btn" @click="toggleToComment">
            <img src="@/assets/icons/new-chat-icon.svg" alt="Icon" />
          </button>
        </a-tooltip>
      </div>
    </div>
    <div class="collaborate-container__tabs" v-if="(discussionType === 'topic' && getInterestGroup.length != 0) || discussionType === 'folder'">
      <button @click="toggleToComment" class="btn" :class="{'active': (getInterestGroup.length != 0 && !toggleToComments === true) || !activeTab}">
          <p class="name">Discuss with AI</p>
      </button>
      <button
        v-if="getInterestGroup.length != 0 && topic.interest.interest !== 'Your PDB' && !topic?.interest?.is_private"
        :class="activeTab === 'public' ? 'active' : ''"
        class="btn"
        @click="changeTab('public')"
      >
        <p class="name">Discuss with Contacts</p>
      </button>
      <button
        v-if="getInterestGroup.length != 0 && topic.interest.interest !== 'Your PDB' && topic?.interest?.is_private"
        :class="activeTab === 'private' ? 'active' : ''"
        @click="changeTab('private')"
        class="btn"
      >
        <p class="name">Discuss with Contacts</p>
      </button>
      <button
        v-if="discussionType == 'folder'"
        :class="activeTab === 'folder' ? 'active' : ''"
        @click="changeTab('folder')"
        class="btn"
      >
        <p class="name">Discuss with Contacts</p>
      </button>
    </div>
    <div class="collaborate-container__body" id="container-body" ref="containerbody" :class="{'collaborate-container__glocal-ai-body': textareaRow == 3}">
      <transition name="fade-slide">
        <div class="collaborate-container__body--search-bar" v-if="isExpanded">
          <div class="input expanded">
            <img src="@/assets/icons/search-icon.svg" alt="Icon" />
            <input
              type="text"
              placeholder="Search"
              v-model="searchChat"
            />
          </div>
        </div>
      </transition>
      <div v-if="paginationLoader && ((isMoreDiscussionChatPage || !hasFolderDiscussionReachedLimit) && discussionCommentsIdArray.length > 0)" class="collaborate-container__body--scroll-loader">
        <the-loader></the-loader>
      </div>
      <template v-if="(searchChat.length !=0 && activeTab==='')">
        <div
            class="collaborate-container__body--question-answer"
            v-for="message in filteredSessionChat"
            :key="message.id"
          >
            <div v-if="message.by === 'user'" class="my-question">
              <img :src="message.user.profile_picture" />
              <h5 v-html="message.highlightedMessage || message.message"></h5>
            </div>
            <ai-comment-card
              v-if="message.by === 'bot'"
              :botMessage="message"
              :highlightedMessage="message.highlightedMessage || message.message"
            ></ai-comment-card>
          </div>
      </template>
      
      <template
        v-if="(toggleToComments === true && activeTab) && (discussionType === 'folder' || discussionType === 'topic')"
      >
        <div
          class="collaborate-container__body--discussion-container"
          v-if="discoverTopicDiscussionLoader"
        >
          <a-skeleton
            v-for="discussionCard in 4"
            :key="discussionCard"
            active
            :avatar="{ shape: 'square' }"
            :title="{ width: '30%' }"
            :paragraph="{ rows: 2, width: ['100%', '50%'] }"
            class="discussion-card-skeleton"
          />
        </div>
        <div
          class="collaborate-container__body--discussion-container"
          v-if="
            !discoverTopicDiscussionLoader && discussionCommentsIdArray.length === 0
          "
        >
          <h5 class="message">No discussions here — yet. Start one now!</h5>
        </div>
        <div ref="scrollDown"
          v-else-if="
            !discoverTopicDiscussionLoader && discussionCommentsIdArray.length > 0
          "
          class="collaborate-container__body--discussion-container"
        >
          <div ref="commentsContainer">
            <template v-for="(id, commentIndex) in discussionCommentsIdArray" :key="id">
              <discussion-card
                :discussionComment="topicComments.get(id)"
                :closeEditLoader="closeEditLoader"
                :deleteLoader="deleteLoader"
                @deleteComment="(comment) => {deleteComment(comment, commentIndex)}"
                @updateComment="(comment) => {updateComment(comment, commentIndex)}"
                @replyComment="showReplyBox"
                @likeComment="likeComment"
                @deleteCommentLike="deleteCommentLike"
              ></discussion-card>
              <div class="reply-comment">
                <discussion-card
                  v-for="(childComment, commentIndex) in topicComments.get(id).child"
                  :key="childComment.id"
                  :discussionComment="childComment"
                  :closeEditLoader="closeEditLoader"
                  :deleteLoader="deleteLoader"
                  @deleteComment="(comment) => {deleteComment(comment, commentIndex)}"
                  @updateComment="(comment) => {updateComment(comment, commentIndex)}"
                  @likeComment="likeComment"
                  @deleteCommentLike="deleteCommentLike"
                  :showReplyCommentButton="false"
                ></discussion-card>
                <div v-if="topicComments.get(id)?.isReplying" class="input">
                  <img :src="loggedInUserProfile?.profile_picture" />
                  <textarea
                    @keyup.enter="repliedComment"
                    name=""
                    id="commentTextarea"
                    cols="30"
                    rows="1"
                    placeholder="Add comment..."
                    @input="handleChange"
                    v-model="repliedComment"
                  ></textarea>
                  <div class="buttons">
                    <a-button
                      :loading="replyLoading"
                      class="btn"
                      :class="{ disabled: isRepliedCommentDisabled }"
                      :disabled="isRepliedCommentDisabled"
                      @click="replyComment(topicComments.get(id))"
                    >
                      <i class="icon icon-send"></i>
                    </a-button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-if="!activeTab && discussionType === 'topic'">
        <a-collapse v-model:activeKey="activeKey" expandIconPosition="right" class="topic-summary-collapse">
          <a-collapse-panel key="1" header="Topic Summary & Relevance">
            <div class="summary">
              <a-skeleton v-if="topicAnalysisLoader" :title="false" active :paragraph="{ rows: 6, width: ['100%', '100%', '100%', '100%', '100%', '60%'] }" />
              <template v-if="Object.keys(topicAnalysis).length > 0 && !topicAnalysisLoader">
                <template v-for="([analysisHeader, anaylsis]) in Object.entries(topicAnalysis)" :key="analysisHeader">
                    <h1>{{ analysisHeader }}</h1>
                    <p>{{ anaylsis }}</p>
                </template>
              </template>
              <p v-if="!topicAnalysis && !topicAnalysisLoader" class="message">No analysis available</p>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </template>
      <div  
        v-if="(!chatSkeletonLoader && sessionChat.length === 0 && toggleToComments === false) && defaultSession" 
        class="collaborate-container__body--default-message"
      >
        <div class="collaborate-container__body--default-message--header">
          <img src="@/assets/icons/glocal-ai-icon-navbar-black.svg" alt="Icon" class="collaborate-container__body--default-message--header--icon" />
          <div class="collaborate-container__body--default-message--header--title">
            <p>Welcome to</p>
            <h1>Glocal Al</h1>
          </div>
        </div>
         <div class="collaborate-container__body--default-message--body">
          <p>Ask everything related to your topic and get answers within seconds with Glocal AI assistant.</p>
         </div>
      </div>
      <!-- <div
        class="collaborate-container__body--default-message"
        v-if="
          (!chatSkeletonLoader &&
            sessionChat.length === 0 &&
            toggleToComments === false)
            &&
            discussionType === 'topic' && defaultSession"
      >
        <img src="@/assets/icons/glocal-ai-icon-navbar-black.svg" alt="Icon" />
        <h1 class="title">Welcome to Glocal AI</h1>
        <a-row :gutter="[18, 10]">
          <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="chat-message-card" @click="selectGivenQuestionsForAI('Tell me some positive news stories.')">
              <h1>Tell me some positive news stories.</h1>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="chat-message-card" @click="selectGivenQuestionsForAI('Summarize key national security trends.')">
              <h1>Summarize key national security trends.</h1>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="chat-message-card" @click="selectGivenQuestionsForAI('Key issues in 2025.')">
              <h1>Key issues in 2025.</h1>
            </div>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div class="chat-message-card" @click="selectGivenQuestionsForAI('Global economy trends.')">
              <h1>Global economy trends.</h1>
            </div>
          </a-col>
        </a-row>
      </div> -->
      <div v-if="!chatSkeletonLoader && toggleToComments === false && searchChat.length === 0">
        <div
          class="collaborate-container__body--question-answer"
          v-for="message in sessionChat"
          :key="message.id"
        >
          <div v-if="message.by === 'user'" class="my-question">
            <img :src="message.user.profile_picture" />
            <h5>{{ message.message }}</h5>
          </div>
          <ai-comment-card
            v-if="message.by === 'bot'"
            :botMessage="message"
          ></ai-comment-card>
        </div>
        <ai-comment-card v-if="botResponseLoader"></ai-comment-card>
      </div>
      
      <template v-if="typingUsers.length > 0">
        <div class="collaborate-container__body--chat-typing">
          <div class="user-images">
            <img v-for="user in typingUsers" :key="user?.user_id" :src="user.profile_picture" class="image">
          </div>
          <div class="dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </template>
    </div>
    <div class="collaborate-container__footer">
      <div class="collaborate-container__footer--comment">
        <img :src="loggedInUserProfile?.profile_picture" v-if="textareaRow == 1" />
        <textarea
          v-model="comment"
          @keyup.enter="createComment"
          name=""
          id="commentTextarea"
          cols="30"
          :rows="textareaRow"
          :placeholder="placeholderText"
          @input="handleChange"
        ></textarea>
        <div class="buttons" :class="{'ai-comment-buttons': textareaRow === 3}">
          <a-button
            :loading="loading"
            @click="createComment()"
            :class="{ disabled: isDisabled }"
            :disabled="isDisabled"
            class="btn"
          >
            <i class="icon icon-send"></i>
          </a-button>
        </div>
      </div>
    </div>
  </div>
  <invite-category
    :visible="inviteCategoryModal"
    @handle-close="inviteCategoryModal = false"
    @show-success-modal="showInvitationSubmit"
    :options="contactArray"
    :categoryId="interestId || folderId"
    :interestGroupId="interestGroupId"
    :selectedTopic="{...topic.interest, permission:topic?.permission}"
    :inviteType="discussionType !== 'topic' ? 'folderInvite' : 'topicInvite'"
  ></invite-category>
  <collaborate-previous-searches-drawer
    :visible="showCollaboratePreviousSearchesDrawer"
    @close-drawer="closeCollaboratePreviousSearchesDrawer"
    @goToChat="toggleToComment"
  >
  </collaborate-previous-searches-drawer>
  <search-modal
    :visible="sowSearchDrawer"
    @close-drawer="closeChatSearchDrawer"
  />
  <all-users-modal
    :visible="visibleAllUsersModal"
    :users="discussionUsers"
    :loadingUserSkeleton="loadingUserSkeleton"
    @closeAllUserModal="closeAllUsersModal"
  >
  </all-users-modal>
</template>

<script>
import moment from "moment";
import debounce from 'lodash.debounce';
import { mapActions, mapGetters, mapMutations } from "vuex";
import DiscussionCard from "../TopicDiscussion/DiscussionCard.vue";
import SearchModal from "../BaseComponents/SearchModal.vue";
import AiCommentCard from "../GlocalAIPageComponents/AICommentCard.vue";
import inviteCategory from "../PdbComponents/InviteToDiscussionModal.vue";
import CollaboratePreviousSearchesDrawer from "./CollaboratePreviousSearchesDrawer.vue";
import AllUsersModal from "../BaseComponents/AllUsersModal.vue";
import TheLoader from "../BaseComponents/TheLoader.vue";
import { marked } from "marked";

export default {
  props:{
    discussionType:{
      default: ()=>'topic',
      type: String
    }
  },
  data() {
    return {
      activeTab: "",
      isChat: false,
      searchChat: "",
      closeEditLoader: false,
      comment: "",
      toggleToComments: false,
      isPublicDropdownOpen: false,
      isPrivateDropdownOpen: false,
      deleteLoader: false,
      replyLoading: false,
      loading: false,
      showMessageModal: false,
      inviteCategory: [],
      inviteCategoryModal: false,
      repliedComment: "",
      isDatePickerVisible: false,
      sowSearchDrawer: false,
      showCollaboratePreviousSearchesDrawer: false,
      options:[],
      visibleAllUsersModal: false,
      placeholderText: "Submit inquiry...",
      loadingUserSkeleton: false,
      paginationLoader: false,
      chatContainterElement: null,
      isPaginationCalled: false,
      defaultSession: true,
      isExpanded: false,
      startDate: null,
      endDate: null,
      textareaRow: 3,
      activeKey: '1',
      publicTopicGroupId:''
    };
  },
  components: {
    CollaboratePreviousSearchesDrawer,
    AiCommentCard,
    DiscussionCard,
    SearchModal,
    inviteCategory,
    AllUsersModal,
    TheLoader
  },
  computed: {
    ...mapGetters({
      discoverTopicDiscussionLoader: "discussion/discoverTopicDiscussionLoader",
      sessionChat: "aiChat/sessionChat",
      chatSectionSkeleton: "aiChat/chatSectionSkeleton",
      botResponseLoader: "aiChat/botResponseLoader",
      topic:"discover/getTopicDetails",
      getSearchedTopic:'discover/getTopic',
      getDiscussionInvitedUsers: 'discussion/getDiscussionInvitedUsers',
      privateDiscussionChatCurrentPage: 'discussion/privateDiscussionChatCurrentPage',
      publicDiscussionChatCurrentPage: 'discussion/publicDiscussionChatCurrentPage',
      isMoreDiscussionChatPage :'discussion/isMoreDiscussionChatPage',
      folderComments: 'folders/getFolderComments',
      folderDiscussionUsers: 'folders/getUsersWithFolderAccess',
      folderUninvitedUsers: 'folders/folderUninvitedUsers',
      typingUsers: 'discussion/typingUsers',
      folderCommentsIdArray: 'folders/folderCommentsIdArray',
      searchedComment: 'discussion/searchedComment',
      hasFolderDiscussionReachedLimit: 'folders/hasFolderDiscussionReachedLimit',
      folderDiscussionCurrentPage: 'folders/folderDiscussionCurrentPage',
      topicAnalysis:'discover/topicAnalysis',
      topicAnalysisLoader: 'discover/topicAnalysisLoader',
      stateActiveTopicTab: 'discover/activeTopicTab'
    }),
    getInterestGroupPrivateId() {
      const resp = this.$store.getters["article/getInterestGroup"];
       const foundElement = resp.find((element) => element.is_private);
      if (foundElement) {
          return foundElement.id;
        }
        return null
    },
    getInterestGroupPublicId() {
      const resp = this.$store.getters["article/getInterestGroup"];
       const foundElement = resp.find((element) => !element.is_private);
      if (foundElement) {
          return foundElement.id;
        }
        return null
    },
    filteredSessionChat() {
      let filtered
      filtered = this.sessionChat.map((message) => {
        if (message.message.toLowerCase().includes(this.searchChat.toLowerCase())) {
          return {
            ...message,
            highlightedMessage: this.highlightText(message.message, this.searchChat),
          };
        }
      }).filter(msg => msg)
      return filtered
    },
    filteredInterest() {
      // Assuming you are using Vue Router to access the route params
      const routeId = this.$route.params.id;

      // Find the object in the array where the interest id matches the route id
      return this.permission.find((item) => item.interest.id === routeId);
    },
    categoryOptions() {
      return this.$store.getters["profile/getUserInterests"];
    },
    isRepliedCommentDisabled() {
      return this.repliedComment.trim() === "";
    },
    loggedInUserProfile() {
      return this.$store.getters["profile/userInformation"].profile;
    },
    isDisabled() {
      return this.comment.trim() === "";
    },
    interestId() {
      return this.$route.params.id;
    },
    paramSessionId() {
      return this.$route.params.id;
    },
    chatSkeletonLoader() {
      return this.chatSectionSkeleton;
    },
    selectedSession() {
      return this.$store.getters["aiChat/activeSession"];
    },
    sessionChatLength() {
      return this.sessionChat.length;
    },
    interestGroupAudience() {
      var value = "";
      this.$store.getters["article/getInterestGroup"].forEach((element) => {
        value = element.is_private;
      });
      return value;
    },
    discussionCommentsIdArray(){
      if (this.discussionType === 'topic'){
        return this.activeTab === "public"
          ? this.$store.getters["discussion/publicTopicCommentsIdArray"]
          : this.$store.getters["discussion/privateTopicCommentsIdArray"];
      }else{
        return this.folderCommentsIdArray
      }
    },
    topicComments:{
      get(){
        if (this.discussionType === 'topic'){
          return this.activeTab === "public"
            ? this.$store.getters["discussion/getPublicDiscussionComments"]
            : this.$store.getters["discussion/getPrivateDiscussionComments"];
        }
        else{
          return this.folderComments
        }
      },
      set(comment){
        if (this.discussionType === 'topic'){
          this.updateCommentObject({comment, group: this.activeTab.toUpperCase()})
        }
      }
    },
    getInterestGroup() {
      const resp = this.$store.getters["article/getInterestGroup"];
      resp.forEach((element) => {
        if (element.is_private) {
          this.privateTopicGroupId = element.id;
          // this.fetchComments('private')

        } else if (!element.is_private) {
          // this.fetchComments('public')
          this.publicTopicGroupId = element.id;
        }
      });
      return resp;
    },
    interestGroupId() { 
     return  this.activeTab === "private"
            ? this.privateTopicGroupId
            : this.publicTopicGroupId
    },
    limitedUsers() {
      return this.discussionUsers.length > 0 ? this.discussionUsers.slice(0, 3) : this.discussionUsers 
    },
    folderId(){
      return this.$route.params.id
    },
    discussionUsers(){
      return this.discussionType === 'topic' ? this.getDiscussionInvitedUsers : this.folderDiscussionUsers
    },
    contactArray(){
      return this.options.filter(user=>!this.discussionUsers.find(discussionUser => discussionUser?.id === user?.value))
    },
    collaborateTitle() {
      return this.discussionType === 'topic' ? "Topic Discussion" : "Topic Discussion"
    },
    showInviteButton() {
      if (this.discussionType === 'topic' && this.activeTab){
        if (this.stateActiveTopicTab !== 'Trending news' && this.stateActiveTopicTab !== 'Your PDB'){
          if (this.topic?.permission !== 'contributor' && this.topic?.interest?.is_private) {
            return true
          }else if (!this.topic?.interest?.is_private) {
            return true
          }else{
            return false
          }
        }else{
          return false
        }
      }else {
        return false
      }
    },
    showSeeAllContibutorsButton() {
      if (this.discussionType === 'topic' && this.activeTab){
        if (this.stateActiveTopicTab !== 'Trending news' && this.stateActiveTopicTab !== 'Your PDB'){
          if (this.topic?.permission === 'contributor' && this.topic?.interest?.is_private) {
            return true
          }else{
            return false
          }
        }else{
          return false
        }
      }else {
        return false
      }
    },
    showDateRageButton(){
      if (this.discussionType === 'topic' && this.activeTab){
        if (this.stateActiveTopicTab !== 'Trending news' && this.stateActiveTopicTab !== 'Your PDB'){
          return true
        }else{
          return false
        }
      }else {
        return false
      }
    },
    showHistoryButton(){
      if (!this.activeTab)
        return true
      else
        return false
      
    },
    showNewInquiryButton(){
      if (!this.activeTab)
        return true
      else 
        return false
    }
  },
  watch: {
    "$route.params.id"(newId, oldId) {
      this.comment = "";
      this.toggleToComments = false;
      this.clearSessionChat();
      this.clearInterestGroup();
      this.activeTab = "";
    },
    sessionChatLength(newVal, oldVal) {
      this.toggleToComments = false;
      this.activeTab = "";
    },
    async activeTab(newVal) {
      this.isPublicDropdownOpen = false;
      this.isPrivateDropdownOpen = false;
      if (newVal === "public" || newVal === "private" |  newVal === "folder") {
         this.placeholderText = "Write a comment..."
         this.textareaRow = 1
      }
      else {
        this.placeholderText = "Submit inquiry..."
        this.textareaRow = 3
      }
      if(newVal === "public")  {
        this.setTopicDiscussionTypeId(this.publicTopicGroupId)
        const payload = {
          interest_group_id: this.publicTopicGroupId,
          interest_id: this.interestId,
          page_size: 3
        }
        await this.$store.dispatch(
          "discussion/fetchDiscussionInvitedUsers",
          payload
        );
      }
      if(newVal === "private") {
        this.setTopicDiscussionTypeId(this.privateTopicGroupId)
        const payload = {
          interest_group_id: this.privateTopicGroupId,
          interest_id: this.interestId,
          page_size: 3
        }
        await this.$store.dispatch(
          "discussion/fetchDiscussionInvitedUsers",
          payload
        );
      }
    },
    discussionCommentsIdArray:{
      handler(comments){
        setTimeout(()=>{ 
          if(comments.length > 0 && !this.isPaginationCalled)
            // if (!this.isPaginationCalled)
          this.$nextTick(() => {
            this.scrollToBottom()
          })
          else{
              this.chatContainterElement.scrollTop = 200
              this.togglePaginationCalled()
          }
          })
      },
      immediate:true,
      deep:true
    },
    async privateDiscussionChatCurrentPage(){ 
      this.togglePaginationCalled()
      this.paginationLoader = true
      await this.fetchComments(null,this.interestId)
      this.paginationLoader = false
    },
    async publicDiscussionChatCurrentPage(){
      this.togglePaginationCalled()
      this.paginationLoader = true
      await this.fetchComments(null,this.interestId)
      this.paginationLoader = false
    },
    discussionType:{
      handler(type){
        if (type === 'topic' && this.activeTab === '') {
          this.placeholderText = 'Submit inquiry...'
          this.textareaRow = 3
        }
        else if (type === 'topic' && (this.activeTab === "public" || this.activeTab === "private")) {
          this.placeholderText = 'Write a comment...'
          this.textareaRow = 1
        }
        else if (type === 'folder' && this.activeTab === 'folder') {
          this.placeholderText = 'Write a comment...'
          this.textareaRow = 1
        }else if (type === 'folder' && !this.activeTab) {
          this.placeholderText = 'Submit inquiry...'
          this.textareaRow = 3 
        }
      },
      immediate:true
    },
    typingUsers: {
      handler(users) {
        if(users.length > 0) {
          this.scrollToBottom()
        }
      },
      immediate: true
    },
    searchChat: {
      handler(searchChat){
        this.debounceSearchComments(searchChat)

      },
      immediate: true
    },
    searchedComment: {
      handler(comment){
        (async ()=>{
          try{
            // if (this.activeTab){
              if (this.discussionType === 'topic' && this.activeTab){
                this.resetDiscussionChatCurrentPage()
                this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');

                this.emptyTopicPublicAndPrivateDiscussion()
                    
                const payload = {
                  interest_group_id: this.activeTab === 'private' ? this.getInterestGroupPrivateId : this.getInterestGroupPublicId,
                  interest_id: this.getSearchedTopic.interest.id,
                  group: this.activeTab.toUpperCase(),
                };

                await this.$store.dispatch('discussion/setDiscussionComments', payload)

                this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');
              }else if (this.discussionType === 'folder' && this.folderId){

                this.resetFolderDiscussionPage()
                this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');

                this.emptyFolderDiscussion()

                await this.fetchFolderComments()
                this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');

              }
          }
          catch(err){
            console.log(err)
            this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');
          }
        })();
      
      },
      immediate: true
    },
    folderDiscussionCurrentPage:{
      handler(){
        (async()=>{
          this.togglePaginationCalled()
          this.paginationLoader = true
          await this.fetchFolderComments()
          this.paginationLoader = false 
        })()
       
      }
    }
  },
  mounted() { 
    this.chatContainterElement = document.getElementById('container-body')
    if (this.chatContainterElement)
    this.chatContainterElement.addEventListener('scroll', ()=>{
      if (this.acitveTab){
        if (
          this.chatContainterElement.scrollTop <= 100 && this.chatContainterElement.scrollTop > 10 
          &&
          !this.paginationLoader
        ) {

          if (this.isMoreDiscussionChatPage && this.discussionType === 'topic')
            this.incrementDiscussionChatCurrentPage(this.activeTab.toUpperCase())
          else if (!this.hasFolderDiscussionReachedLimit && this.discussionType === 'folder'){
            this.incOrDecFolderDiscussionPageCounter({action:'inc'})
          }
        }
      }
    })
  },
  
  methods: {
    ...mapMutations({
      clearSessionChat: "aiChat/CLEAR_SESSION_CHAT",
      clearInterestGroup: "article/clearInterestGroup",
    }),
    moment,
    ...mapActions({
      getMessages: "aiChat/getMessages",
      setActiveSession: "aiChat/setActiveSession",
      emptySectionChats: "aiChat/emptySectionChats",
      toggleChatSectionSkeleton: "aiChat/toggleChatSectionSkeleton",
      incrementDiscussionChatCurrentPage : 'discussion/incrementDiscussionChatCurrentPage',
      resetDiscussionChatCurrentPage: 'discussion/resetDiscussionChatCurrentPage',
      setTopicDiscussionTypeId: 'discover/setTopicDiscussionTypeId',
      connectDiscussionSocket: 'discussion/connectDiscussionSocket',
      sendTypingStatusOfUsers: 'discussion/sendTypingStatusOfUsers',
      updateCommentObject: 'discussion/updateCommentObject',
      setSearchedComment: 'discussion/setSearchedComment',
      emptyTopicPublicAndPrivateDiscussion: 'discussion/emptyTopicPublicAndPrivateDiscussion',
      resetFolderDiscussionPage: 'folders/resetFolderDiscussionPage',
      incOrDecFolderDiscussionPageCounter: 'folders/incOrDecFolderDiscussionPageCounter',
      emptyFolderDiscussion: 'folders/emptyFolderDiscussion',
    }),
    scrollToElement() {
      this.$nextTick(() => {
          const el = this.$refs.commentsContainer;
          if (el) {
            el.scrollIntoView({behavior: "smooth", block: "end"});
          }
        });
      },
    highlightText(text, searchText) {
      // Highlight the matching text
      const regex = new RegExp(`(${searchText})`, 'gi');
      return text.replace(regex, '<span class="highlight">$1</span>');
    },
    async getSearchChat() {
      if (this.discussionType === 'topic'){
          try {
            const payload = {
              search: this.searchChat,
            };
            const res = await this.$store.dispatch("aiChat/searchChat", payload);
            if (res.status === 200) {
              this.sowSearchDrawer = true;
            }
          } catch (error) {
            console.log(error);
          }
      }
    },
    debouncedSearch: debounce(function() {
      this.getSearchChat();
    }, 3000),
    showInvitationSubmit() {
      this.showMessageModal = true;
      this.message = {
        title: "Invitation Sent Successfully",
        type: "success",
      };
    },
    async handleDateChange(dates, dateStrings) {
      const [startDate, endDate] = dateStrings;
      this.startDate = startDate
      this.endDate = endDate
      console.log("DATE STRINGS", this.startDate, this.endDate)
      // await this.filterCommentsWithDate(startDate, endDate);
      // this.isDropdownOpen = false;
      // this.isDatePickerVisible = false;
    },
    async filterCommentsWithDate(startDate, endDate) {
      let interestOrFolderOrArticleId = null;
      interestOrFolderOrArticleId = this.interestId;
      const filterOptions = {
        startDate: startDate,
        endDate: endDate,
      };
      this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
      await this.fetchComments(
        null,
        interestOrFolderOrArticleId,
        filterOptions
      );
      this.$store.dispatch("discussion/toggleDiscoverTopicCommentLoader");
    },
    async changeTab(tab) {
      this.activeTab = tab;
      this.toggleToComments = true;
      const isPrivate = tab === 'private';
      const isPublic = tab === 'public';
      this.resetDiscussionChatCurrentPage()
      if (isPrivate || isPublic) {
        try {
          this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');
          
          const payload = {
            interest_group_id: isPrivate ? this.getInterestGroupPrivateId : this.getInterestGroupPublicId,
            interest_id: this.getSearchedTopic.interest.id,
            group: isPrivate ? 'PRIVATE' : 'PUBLIC',
          };

          const socketPayload = {
            interest_group: isPrivate ? this.getInterestGroupPrivateId : this.getInterestGroupPublicId,
            isPrivate: isPrivate ? true : false
          }
          this.connectDiscussionSocket(socketPayload)
          await this.$store.dispatch('discussion/setDiscussionComments', payload)
        } catch (error) {
          console.error(error);
        } finally {
          this.$store.dispatch('discussion/toggleDiscoverTopicCommentLoader');
        }
      }
    },
    async replyComment(parentComment) {
      try {
        this.replyLoading = true;
        if( this.discussionType === 'topic') {
        const payload = {
          comment: this.repliedComment,
          parent: parentComment.id,
          interest_id: parentComment.interest,
          interest_group_id:
            this.activeTab === "private"
              ? this.privateTopicGroupId
              : this.publicTopicGroupId,
        };

        await this.$store.dispatch(
          "discussion/createDiscussionComment",
          payload
        );
        this.repliedComment = "";
      }
      else{
        const form = new FormData();
        form.append("comment", this.repliedComment);
        form.append("parent", parentComment.id);
        const payload = {
          comment: form,
          folderId: parentComment.folder,
        };

        await this.$store.dispatch(
          "folders/createFolderComment",
          payload
        );

        // await this.fetchFolderComments();
        this.repliedComment = "";
        this.replyLoading = false;
      }
      } catch (err) {
        console.log(err);
      } finally {
        this.replyLoading = false;
      }
    },
    toggleToComment() {
      this.toggleToComments = false;
      this.activeTab = "";
      this.$store.commit("aiChat/CLEAR_SESSION_CHAT");
    },
    visibleInvitationCategory() {
      this.inviteCategoryModal = true;
      let obj = {
        id: this.interestId,
        name: this.interestName,
      };
      this.inviteCategory.push(obj);
    },
    async fetchComments(
      comment = null,
      interest_id = null,
      filterOptions = null,
      page,
    ) {
      const payload = {
        interest_group_id:
          this.activeTab === "private"
            ? this.privateTopicGroupId
            : this.publicTopicGroupId,
        interest_id: comment ? comment.interest : interest_id,
        group: this.activeTab.toUpperCase(),
        filterOptions: filterOptions ? filterOptions : null,
      }

      if (page > 0 ){
        payload.page = page
      }

     await this.$store.dispatch(
        "discussion/setDiscussionComments",
        payload
      );
    },
    scrollToBottom() {
      const chatContainterElement = document.getElementById('container-body')
      if (chatContainterElement)
        chatContainterElement.scrollTop = chatContainterElement.scrollHeight;
      // console.log("NEW COMMMENT SCROLL", chatContainterElement)
    },
    async likeComment({ discussionComment, action }) {
      try{
      if (this.discussionType === 'topic'){
        const payload = {
          interestGroupId:
            this.activeTab === "private"
              ? this.privateTopicGroupId
              : this.publicTopicGroupId,
          interestId: discussionComment.interest,
          commentId: discussionComment.id,
          action,
          group: this.activeTab.toUpperCase()
        };
        
        await this.$store.dispatch("discussion/likeComment", payload);
      }
      else {
        const payload = {
          commentId: discussionComment.id,
          action,
        };
        await this.$store.dispatch("folders/likeFolderComment", payload);
      }
      this.$showToast({message:'Reaction recorded successfully.', type:'success'}) 
    }
    catch(err){
      console.log(err)
    }
      
      // this.fetchComments(discussionComment);
    },
    async deleteCommentLike(discussionComment) {
      try{
        if (this.discussionType === 'topic') {
          const payload = {
            interestGroupId:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.publicTopicGroupId,
            interestId: discussionComment.interest,
            commentId: discussionComment.id,
            group: this.activeTab.toUpperCase()
          };
          await this.$store.dispatch("discussion/deleteLikeDislike", payload);
        } else if (this.isArticleView) {
          const payload = {
            article_id: discussionComment.article_data,
            comment_id: discussionComment.id,
          };
          await this.$store.dispatch("discover/deleteLikeDislike", payload);
          this.discussionComments.forEach((comment) => {
            comment[`current_user_like`] = null;
            comment[`current_user_dislike`] = null;
          });
          this.fetchComments();
        } else {
          await this.$store.dispatch(
            "folders/deleteLikeDislike",
            discussionComment.id
          );
        }
        this.$showToast({message:'Reaction recorded successfully.', type:'success'}) 
      }
      catch(err){
        console.log(err)
      }
    },
    showReplyBox(parentComment) {
      this.discussionCommentsIdArray.forEach((commentId) => {
        if (commentId === parentComment.id) {
          const comment = this.topicComments.get(commentId)
          if (comment.isReplying) {
            comment.isReplying = false;
            this.topicComments.set(commentId, comment)
          } else {
            comment.isReplying = true;
            this.topicComments.set(commentId, comment)
          }
        } else {
          const comment = this.topicComments.get(commentId)
          comment.isReplying = false;
          this.topicComments.set(commentId, comment)
        }
      });


      // this.discussionComments.forEach((comment) => {
      //   if (comment.id === parentComment.id) {
      //     if (comment.isReplying) {
      //       comment.isReplying = false;
      //     } else {
      //       comment.isReplying = true;
      //     }
      //   } else {
      //     comment.isReplying = false;
      //   }
      // });
    },
    async deleteComment(comment, commentIndex) {
      try {
        this.deleteLoader = true;
        if (this.$route.path.includes("discover")) {
          const payload = {
            discussion_id: comment.id,
            interest_id: comment.interest,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.publicTopicGroupId,
            parent: comment.parent,
            group: this.activeTab.toUpperCase(),
          };
          await this.$store.dispatch(
            "discussion/deleteDiscussionComments",
            payload
          );
          
          // await this.fetchComments(comment);
          this.deleteLoader = false;
       
        } else if (this.isArticleView) {
          try {
            const payload = {
              comment_id: comment.id,
              article_id: comment.article_data,
            };
            const response = await this.$store.dispatch(
              "discover/deleteDiscoverArticleComment",
              payload
            );
            if (response.status === 204) {
              await this.fetchComments();
              this.deleteLoader = false;
            }
          } catch (err) {
            console.log(err);
            this.deleteLoader = false;
          }
        } else {
          const payload = {
            commentId: comment.id,
            folderId: comment.folder,
            parent: comment.parent,
            commentIndex
          };
          await this.$store.dispatch(
            "folders/deleteFolderComments",
            payload
          );
          // if (response.status === 204) {
            // await this.fetchComments(comment);
            // await this.fetchFolderComments()
            // this.deleteLoader = false;
          // }
        }
        this.$showToast({message:'Comment removed successfully.', type:'success'}) 
      } catch (err) {
        console.log(err);
      }finally{
        this.deleteLoader = false;
      }
    },
    async updateComment(comment, commentIndex) {
      try {
        this.closeEditLoader = false;
        if (this.$route.path.includes("discover")) {
          const payload = {
            comment: comment.editedComment,
            discussion_id: comment.id,
            interest_id: comment.interest,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.publicTopicGroupId,
            group: this.activeTab.toUpperCase(),
          };
          const response = await this.$store.dispatch(
            "discussion/updateDiscussionCommentst",
            payload
          );
          if (response.status === 200) {
            this.closeEditLoader = true;
          }
        } else if (this.isArticleView) {
          const payload = {
            comment: comment.editedComment,
            comment_id: comment.id,
            article_id: comment.article_data,
          };
          const response = await this.$store.dispatch(
            "discover/updateDiscoverArticleComment",
            payload
          );
          if (response.status === 200) {
            this.fetchComments();
            this.closeEditLoader = true;
          }
        } else {
          const form = new FormData();
          form.append("comment", comment.editedComment);
          const payload = {
            comment: form,
            commentId: comment.id,
            folderId: comment.folder,
            commentIndex
          };
          const response = await this.$store.dispatch(
            "folders/updateFolderComment",
            payload
          );
          if (response.status === 200) {
            this.closeEditLoader = true;
          }
        }
        this.$showToast({message:'Comment updated successfully.', type:'success'}) 
      } catch (err) {
        console.log(err);
        this.closeEditLoader = true;
      }
    },
    async createComment() {
      try {
        this.loading = true;
        // check for discussion type if it is topic or folder
        if (this.discussionType === 'topic'){
        if (this.toggleToComments === true) {
          const payload = {
            comment: this.comment,
            parent: null,
            interest_id: this.interestId,
            interest_group_id:
              this.activeTab === "private"
                ? this.privateTopicGroupId
                : this.activeTab === "public"
                ? this.publicTopicGroupId
                : this.topicGroupId,
          };
          const response = await this.$store.dispatch(
            "discussion/createDiscussionComment",
            payload
          );
            this.comment = "";
            this.resetDiscussionChatCurrentPage()

        } else {
          if (this.selectedSession) {
            const commentDetails = {
              message: this.comment,
              chat_bot_session: this.selectedSession.id,
            };
            await this.$store.dispatch("aiChat/createMessage", commentDetails);
            this.comment = "";
            // this.scrollToBottom()
          } else {
            this.$store.dispatch("aiChat/createSession", this.comment);
            this.comment = "";
          }
          }
        }
        else{
          if (this.toggleToComments === true){
            await this.createFolderDiscussionComment()
          }
          else{
            if (this.selectedSession) {
              const commentDetails = {
                message: this.comment,
                chat_bot_session: this.selectedSession.id,
              };
            await this.$store.dispatch("aiChat/createMessage", commentDetails);
            this.comment = "";
            } else {
              this.$store.dispatch("aiChat/createSession", this.comment);
              this.comment = "";
            }
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    AddNewChat() {
      this.$store.commit("aiChat/CLEAR_SESSION_CHAT");
      this.toggleToComments = false;
      this.activeTab = "";
    },
    toggleDropdown(val) {
      if (val === "public") {
        this.isPublicDropdownOpen = !this.isPublicDropdownOpen;
      } else if (val === "private") {
        this.isPrivateDropdownOpen = !this.isPrivateDropdownOpen;
      }
    },
    showDatePicker(event) {
      event.stopPropagation()
      this.isDatePickerVisible = !this.isDatePickerVisible;
      this.$nextTick(()=>{
        window.addEventListener('click', this.handleClickOutside)
      })
    },
    closeCollaboratePreviousSearchesDrawer() {
      this.showCollaboratePreviousSearchesDrawer = false;
    },
    closeChatSearchDrawer() {
      this.sowSearchDrawer = false;
    },
    openCollaboratePreviousSearchesDrawer() {
      this.showCollaboratePreviousSearchesDrawer = true;
    },
    async openAllUsersModal(type) {
      this.visibleAllUsersModal = true;
      let payload;
      if (type === "public") {
        payload = {
          interest_group_id: this.publicTopicGroupId,
          interest_id: this.interestId,
          page_size: 100
        };
      } else if (type === "private") {
        payload = {
          interest_group_id: this.privateTopicGroupId,
          interest_id: this.interestId,
          page_size: 100
        };
      }
      this.visibleAllUsersModal = true;
      this.loadingUserSkeleton = true; // Set loading before fetching users

      try {
        if ( this.discussionType === 'topic'){
          await this.$store.dispatch("discussion/fetchDiscussionInvitedUsers", payload);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        this.loadingUserSkeleton = false; // Set loading to false once fetching is complete
      }
    },
    closeAllUsersModal() {
      this.visibleAllUsersModal = false;
    },
    togglePaginationCalled(){
      this.isPaginationCalled = !this.isPaginationCalled
    },
    selectGivenQuestionsForAI(question){
      this.defaultSession = false
      if (!this.loading){
        this.comment = question
        this.createComment()
      }
    },
    async createFolderDiscussionComment(){
      const form = new FormData();
      form.append("comment", this.comment);
      const folderPayload = {
        comment: form,
        folderId: this.folderId,
      };
      const response = await this.$store.dispatch(
        "folders/createFolderComment",
        folderPayload
      );
      if (response.status === 201) {
        this.comment = "";
        // this.discussionComments.push(response.data);
        // this.fetchFolderComments();
        this.loading = false;
      }
    },
    async fetchFolderComments(filterOptions){
      const payload = {
          folderId: this.folderId,
          filterOptions: filterOptions ? filterOptions : null,
        };
      await this.$store.dispatch("folders/fetchFolderComments", payload);
    },
    toggleSearch() {
      this.isExpanded = !this.isExpanded;
    },
    async applyFilter(){
      this.isPublicDropdownOpen = false;
      this.isPrivateDropdownOpen = false
      this.isDatePickerVisible = false;
      await this.filterCommentsWithDate(this.startDate, this.endDate);
    },
    handleClickOutside(event) {

      // console.log("EVENT", event.target)
      const classList = event.target.classList;
      const targetsClass = Array.from(classList).join(' ')

      //Check if any current target's parent class has 'ant-calendar', if not close the dropdown and date picker      
      if (!event.target.closest('.ant-calendar') && !targetsClass.includes('ant-calendar') && !targetsClass.includes('apply-filter-button')) 
      {
        this.isDatePickerVisible = false;
        this.isPublicDropdownOpen = false
        this.isPrivateDropdownOpen = false
      }
    },
    handleChange(e){
      if (e.type === 'input'){
        this.sendTypingStatusOfUsers(true)
        this.falsifyTypingStatusOfUsers()
      }
    },
    falsifyTypingStatusOfUsers: debounce(function() {
      this.sendTypingStatusOfUsers(false);
    }, 1000),
    debounceSearchComments: debounce(function(searchChat) {
       if ((this.activeTab && this.discussionType === 'topic') || this.discussionType === 'folder' ) {
            this.setSearchedComment(searchChat)
        }
    }, 500),
  },
};
</script>

<style lang="scss">

.highlight {
  background-color: yellow;
}
.collaborate-container {
  border: 1px solid $color-dark-grey-5;
  border-radius: 2rem;
  height: calc(100vh - 16.4rem);
  overflow: hidden;
  position: relative;
  margin: 0 1rem;
  @include respond(tab-port) {
    margin: 2rem 1rem;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color-dark-grey-5;
    padding: 1.9rem 2rem;
    gap: 2rem;
    &--left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: 0.5rem;
      &--title {
        color: $color-black !important;
        font-size: 2rem;
        line-height: normal;
        font-family: $font-primary-bold;
        margin-bottom: 0;
        @include respond(phone-x-small) {
          font-size: 2.2rem;
          line-height: normal;
        }
      }
      &--topic-title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        svg {
          width: 2rem;
          height: auto;
          margin-top: -0.1rem;
          @include respond(phone-x-small) {
            width: 2.5rem;
          }
        }
        h1 {
          color: $color-black;
          font-size: 2rem;
          line-height: normal;
          font-family: $font-primary-bold;
          margin-bottom: 0;
          @include respond(phone-x-small) {
            font-size: 2.2rem;
            line-height: normal;
          }
        }
      }
    }
    &--right {
      display: flex;
      align-items: center;
      gap: 1rem;
      position: relative;
      &--btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $color-white;
        line-height: normal;
        cursor: pointer;
        padding: 0;
        border: none;
        outline: none;
        padding: 0.5rem;
        position: relative;
        img {
          width: 2rem;
          height: 2rem;
          opacity: 0.7;
          @include respond(phone-x-small) {
            width: 2.5rem;
            height: 2.5rem;
          }
        }
        .ant-calendar-picker, .ant-calendar-picker-input {
          height: 0;
          width: 0;
          padding: 0;
          border: none;
          .ant-calendar-range-picker-separator {
            display: none;
          }
        }
      }
      .group-icon-btn {
        padding: 0;
        margin: 0 0.3rem;
        img {
          width: 2.5rem;
          height: 2.5rem;
          @include respond(phone-x-small) {
            width: 3rem;
            height: 3rem;
          }
        }
      }
    }
  }
  &__tabs {
    width: calc(100% -  4rem);
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1.8rem 2rem;
    padding: 0.4rem 0.5rem;
    gap: 2rem;
    background-color: #f4f4f4;
    border-radius: 1rem;
    .btn {
      display: flex;
      align-items: center;
      height: 3.5rem;
      padding: 0 1.6rem;
      border-radius: 1rem !important;
      border: none;
      outline: none;
      cursor: pointer;
      background-color: #f4f4f4;
      color: #434343;
      width: 50%;
      justify-content: center;
      svg {
        width: 1.7rem;
        margin-right: 0.6rem;
        fill: #434343;
        height: auto;
      }
      .name {
        width: max-content;
        font-size: 1.4rem;
        line-height: normal;
        font-family: $font-primary-medium;
        margin-bottom: 0;
      }
      // .dropdown {
      //   margin-left: auto;
      //   position: relative;
      //   display: block;
      //   margin-right: -0.5rem;
      //   &__dropdown-btn {
      //     background-color: transparent;
      //     border: none;
      //     outline: none;
      //     padding: 0;
      //     cursor: pointer;
      //     width: 1.3rem;
      //     margin-left: 0.5rem;
      //     height: auto;
      //     line-height: normal;
      //     display: flex;
      //     align-items: center;
      //     justify-content: center;
      //     .icon {
      //       font-size: 1.4rem;
      //       color: $color-black;
      //       @include respond(phone-x-small) {
      //         font-size: 1.6rem;
      //         margin-top: 0.1rem;
      //       }
      //     }
      //     .icon-add_plus {
      //       transform: rotate(45deg);
      //     }
      //   }
      //   &__dropdown-menu {
      //     display: block;
      //     position: absolute;
      //     background-color: $color-white;
      //     box-shadow: 0px 4px 24.6px 0px #00000040;
      //     z-index: 3;
      //     right: -0.2rem;
      //     border-radius: 0.8rem;
      //     min-width: 13rem;
      //     top: 18px;
      //     margin-bottom: 0;
      //     @include respond(phone-x-small) {
      //       top: 13px;
      //     }
      //     li {
      //       padding: 1rem 2.2rem;
      //       cursor: pointer;
      //       transition: all 0.3s ease-in-out;
      //       list-style: none;
      //       display: block;
      //       width: 100%;
      //       font-family: $font-primary-medium;
      //       font-size: 1.6rem;
      //       line-height: normal;
      //       color: $color-black;
      //       border-bottom: 1px solid #0000001a;
      //       &:hover {
      //         background-color: #f5f5f5;
      //         border-radius: 1rem;
      //       }
      //       span {
      //         display: block;
      //         width: max-content;
      //       }
      //       &:last-child {
      //         border-bottom: none;
      //       }
      //       .ant-calendar-picker {
      //         .ant-calendar-picker-input,
      //         .ant-calendar-picker-icon {
      //           display: none !important;
      //         }
              
      //       }
      //       .ant-calendar-panel .ant-calendar-footer-extra .footer-container .ant-tag{
      //         cursor: pointer !important;
      //       }
      //     }
      //   }
      // }
    }
    .active {
      background-color: $color-primary;
      color: $color-white;
      svg {
        fill: $color-white;
      }
      // .dropdown {
      //   &__dropdown-btn {
      //     .icon {
      //       color: $color-white;
      //     }
      //   }
      // }
    }
    // .glocal-ai-btn {
    //   display: flex;
    //   align-items: center;
    //   height: 3.8rem;
    //   padding: 0 1.6rem;
    //   border-radius: 100px !important;
    //   border: none;
    //   outline: none;
    //   cursor: pointer;
    //   background-color: #ebebeb;
    //   color: #434343;
    //   width: max-content;
    //   .name {
    //     width: max-content;
    //     font-size: 1.4rem;
    //     line-height: normal;
    //     font-family: $font-primary-medium;
    //     margin-bottom: 0;
    //   }
    //   .ant-dropdown-link {
    //     margin-right: -0.5rem;
    //     margin-left: 0.5rem;
    //   }
    //   .icon {
    //     cursor: pointer;
    //     font-size: 1.4rem;
    //     color: $color-black;
    //     @include respond(phone-x-small) {
    //       font-size: 1.6rem;
    //     }
    //   }
    // }
    // .glocal-ai-btn-active {
    //   background-color: $color-primary;
    //   .icon,
    //   .name {
    //     color: $color-white;
    //   }
    // }
  }
  &__body {
    position: relative;
    height: calc(100vh - 33.5rem);
    overflow-y: auto;
    padding-top: 0;
    &--search-bar {
      display: flex;
      align-items: center;
      gap: 1rem;
      background-color: $color-white;
      padding: 0 2rem 1.3rem;
      position: sticky;
      top: 0;
      z-index: 2;

      .input {
        height: 4.4rem;
        background-color: #f4f4f4;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        overflow: hidden;
        border: none;
        width: 100%;
        transition: background 0.3s;
        position: relative;
        img {
          width: 1.8rem;
          height: auto;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 1.8rem;
          opacity: 0.6;
        }
        input {
          width: 100%;
          padding: 0 1.8rem 0 4.5rem;
          background-color: transparent;
          border: none;
          font-size: 1.6rem;
          font-family: $font-primary;
          color: $color-black;
          height: 100%;
          outline: none;
          &::placeholder {
            color: $color-placeholder;
          }
        }
      }
      // .search-icon-btn {
      //   height: 2.5rem;
      //   width: 2.5rem;
      //   line-height: normal;
      //   background-color: transparent;
      //   border: none;
      //   outline: none;
      //   cursor: pointer;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   opacity: 0.8;
      //   .icon {
      //      font-size: 2.2rem;
      //      line-height: normal;
      //      color: $color-black;
      //      margin-right: 0;
      //   }
      //   @include respond(phone-x-small) {
      //     height: 4rem;
      //     width: 4rem;
      //     .icon {
      //       font-size: 2.5rem;
      //     }
      //   }
      // }
      // .all-collaborate {
      //   display: flex;
      //   align-items: center;
      //   margin-left: 1.6rem;
      //   .images {
      //     display: flex;
      //     align-items: center;
      //     .img {
      //       margin-left: -1.6rem;
      //       width: 4rem;
      //       height: 4rem;
      //       border-radius: 100%;
      //       background-color: #ebebeb;
      //     }
      //     .add-btn {
      //       width: 4rem;
      //       height: 4rem;
      //       border-radius: 100% !important;
      //       background-color: #d6d6d6;
      //       display: flex;
      //       align-items: center;
      //       outline: none;
      //       border: none;
      //       justify-content: center;
      //       cursor: pointer;
      //       margin-left: -1.6rem;
      //       img {
      //         width: 2.3rem;
      //         height: auto;
      //       }
      //     }
      //   }
      //   button {
      //     font-size: 1.4rem;
      //     line-height: normal;
      //     background-color: transparent;
      //     color: $color-black;
      //     font-family: $font-primary-medium;
      //     display: inline-block;
      //     width: max-content;
      //     height: 2.5rem;
      //     border: none;
      //     outline: none;
      //     cursor: pointer;
      //     margin-left: 0.8rem;
      //   }
      //   @include respond(phone-x-small) {
      //     .images {
      //       .img {
      //         width: 4.5rem;
      //         height: 4.5rem;
      //         margin-left: -1rem;
      //       }
      //       .add-btn {
      //         width: 4.5rem;
      //         height: 4.5rem;
      //         img {
      //           width: 2.3rem;
      //         }
      //       }
      //     }
      //   }
      // }
      // .add-new-chat-btn {
      //   height: auto;
      //   width: auto;
      //   line-height: normal;
      //   background-color: transparent;
      //   border: none;
      //   outline: none;
      //   cursor: pointer;
      //   img {
      //     width: 2.5rem;
      //   }
      //   @include respond(phone-x-small) {
      //     img {
      //       width: 3rem;
      //     }
      //   }
      // }
    }
    &--scroll-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: fit-content;
      margin-bottom: 2rem;
      .ant-spin {
        .anticon {
          font-size: 3rem !important;
        }
      }
      p {
        font-size: 1.6rem;
        margin-bottom: 0;
        font-family: $font-primary;
        margin-left: 0.5rem;
      }
    }
    // &--default-message {
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    //   justify-content: center;
    //   margin-bottom: 1.5rem;
    //   width: 100%;
    //   margin-top: auto;
    //   padding: 0 1rem;
    //   img {
    //     width: 4.5rem;
    //     height: auto;
    //     margin-bottom: 1rem;
    //   }
    //   .title {
    //     font-size: 2rem;
    //     font-family: $font-primary-bold;
    //     margin-bottom: 1.5rem;
    //     color: $color-black;
    //     line-height: 2.6rem;
    //     text-align: center;
    //   }
    //   .ant-row {
    //     width: 100%;
    //     margin-top: 1rem;
    //   }
    //   .chat-message-card {
    //     border: 1px solid $color-dark-grey-5;
    //     padding: 1rem 1.3rem;
    //     border-radius: 1rem;
    //     background-color: $color-white;
    //     cursor: pointer;
    //     h1 {
    //       font-size: 1.4rem;
    //       font-family: $font-primary-medium;
    //       margin-bottom: 0;
    //       color: $color-black;
    //       line-height: 1.8rem;
    //       text-align: left;
    //       overflow: hidden;
    //       display: -webkit-box;
    //       -webkit-line-clamp: 1; /* number of lines to show */
    //       line-clamp: 1;
    //       -webkit-box-orient: vertical;
    //       width: 100%;
    //     }
    //   }
    // }
    .topic-summary-collapse {
      background-color: transparent;
      border: none;
      padding: 0 2rem;
      margin-bottom: 2rem;
      .ant-collapse-item {
        border: none;
        background-color: #F5F5F5;
        border: 1px solid $color-dark-grey-5;
        border-radius: 1rem;
        padding: 1.6rem 1.6rem 0;
        .ant-collapse-header {
          padding: 0;
          border-radius: 0;
          border: none;
          background-color: transparent;
          font-size: 1.8rem;
          font-family: $font-primary-medium;
          line-height: normal;
          margin-bottom: 1.6rem;
          color: $color-black;
          opacity: 0.7;
          display: flex;
          align-items: center;
          gap: 1rem;
          justify-content: space-between;
          @include respond(phone-large) {
            font-size: 2.2rem;
          }
          .anticon {
            position: relative;
            top: unset;
            left: unset;
            right: unset;
            bottom: unset;
            order: 2;
            transform: unset;
            font-size: 1.6rem;
            @include respond(phone-large) {
              font-size: 2rem !important;
            }
            svg {
              transform: rotate(90deg);
              color: $color-black;
              fill: $color-black;
              opacity: 0.7;
            }
          }
        }
        .ant-collapse-content {
          border: none;
          background-color: transparent;
          margin-top: -0.5rem;
          .ant-collapse-content-box {
            padding: 0;
            background-color: transparent;
            .summary {
              margin-bottom: 1.8rem;
              h1 {
                font-size: 1.8rem;
                font-family: $font-primary-medium;
                line-height: normal;
                margin-bottom: 0.9rem;
                color: $color-black;
                text-transform: capitalize;
                margin-top: 1.8rem;
                @include respond(phone-large) {
                  font-size: 2.2rem;
                }
                &:first-child {
                  margin-top: 1rem;
                }
              }
              p, .message {
                font-size: 1.4rem;
                font-family: $font-primary;
                line-height: 2rem;
                margin-bottom: 0;
                color: #696969;
                @include respond(phone-large) {
                  font-size: 1.8rem;
                  line-height: 2.5rem;
                }
              }
              .message {
                margin-top: 2rem;
                text-align: center;
              }
              .ant-skeleton {
                .ant-skeleton-content {
                  .ant-skeleton-paragraph {
                    margin: 0;
                    li {
                      height: 2rem;
                    }
                  }
                }
                .ant-skeleton-content .ant-skeleton-paragraph > li + li {
                  margin-top: 1.8rem;
                }
              }
            }
          }
        }
      }
      .ant-collapse-item-active {
        .ant-collapse-header {
          .anticon {
            svg {
              transform: rotate(-90deg) !important;
            }
          }
        }
      }
    }
    &--default-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.5rem;
      width: 100%;
      margin-top: auto;
      padding: 0 2rem;
      gap: 1.8rem;
      &--header {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: auto;
        gap: 1.1rem;
        &--icon {
          width: 4.4rem;
          height: auto;
          margin-top: -0.5rem;
        }
        &--title {
          display: flex;
          flex-direction: column;
          p {
            font-size: 1rem;
            font-family: $font-primary;
            margin-bottom: 0.4rem;
            color: $color-black;
            line-height: normal;
            opacity: 0.6;
          }
          h1 {
            font-size: 2.4rem;
            font-family: $font-primary-bold;
            margin-bottom: 0;
            color: $color-black;
            line-height: normal;
          }
        }
      }
      &--body {
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          font-size: 1.4rem;
          font-family: $font-primary;
          margin-bottom: 0;
          color: $color-black;
          line-height: 2rem;
          opacity: 0.6;
          text-align: center;
          max-width: 70%;
        }
      }
    }
    &--question-answer {
      .my-question {
        display: flex;
        align-items: flex-start;
        padding: 0 2rem;
        img {
          width: 3rem;
          height: 3rem;
          border-radius: 100%;
          object-fit: fill;
          margin-right: 1rem;
          background-color: #e1e1e1;
        }
        h5 {
          font-size: 1.6rem;
          font-family: $font-primary-medium;
          margin-bottom: 0;
          color: $color-black;
          line-height: 2.2rem;
          margin-top: 0.5rem;
        }
      }
    }
    .ai-comment-card {
      margin: 1.5rem 0 2rem;
      padding: 0 2rem;
      &__ai-answer {
        img {
          width: 3rem;
          height: 3rem;
          margin-right: 1rem;
        }
        h4 {
          font-size: 1.6rem;
          line-height: 2.2rem;
          margin-top: 0.5rem;
          h1, h2, h3, h4 {
            font-size: 2rem;
            font-family: $font-primary-medium;
          }
          * {
            color: $color-black;
          }
        }
        &--typing {
          margin-top: 1.5rem;
          span {
            width: 0.6rem;
            height: 0.6rem;
            &:nth-child(2) {
              margin-left: 1rem * 1;
            }

            &:nth-child(3) {
              margin-left: 1rem * 2;
            }
          }
        }
      }
    }
    &--discussion-container {
      padding: 0 2rem;
      .discussion-card {
        padding: 1.5rem 1.5rem 1.6rem;
        margin: 0 0 2rem;
        &__header {
          margin-bottom: 1.5rem;
          &--image {
            width: 3rem;
            height: 3rem;
          }
          &--name-date {
            h2 {
              font-size: 1.4rem;
              line-height: 1.8rem;
            }
            p {
              font-size: 1.2rem;
              line-height: 1.6rem;
            }
          }
          &--like-ellipse {
            gap: 1.3rem;
            .btn {
              gap: 0.7rem;
              .icon {
                font-size: 1.6rem;
              }
              p {
                font-size: 1.4rem;
                line-height: 1.6rem;
              }
            }
            .ant-dropdown-link {
              margin-left: 0.5rem;
              .icon {
                font-size: 1.6rem;
              }
            }
          }
        }
        &__body {
          &--description {
            font-size: 1.6rem;
            line-height: 2.2rem;
            .link-preview {
              .link-card {
                margin: 1.5rem 0 1.7rem;
                &__image {
                  width: 6rem;
                  height: 5.9rem;
                }
                &__content {
                  padding: 1rem 1rem;
                  width: calc(100% - 6rem);
                  &--title {
                    font-size: 1.6rem;
                    line-height: 2rem;
                  }
                  &--author {
                    margin-top: 0.3rem;
                    p {
                      font-size: 1.2rem;
                      line-height: 1.6rem;
                    }
                  }
                }
              }
            }
          }
          &--reply-btn {
            .btn {
              font-size: 1.4rem;
              img {
                width: 1.4rem;
                height: auto;
              }
            }
          }
          &--edit {
            .btn-textarea {
              padding: 0.5rem 0.8rem;
              textarea {
                font-size: 1.6rem;
                line-height: 2.2rem;
              }
              .send-btn {
                .icon {
                  font-size: 1.6rem;
                }
              }
            }
          }
        }
      }
      .reply-comment {
        padding-left: 3rem;
        position: relative;
        margin-bottom: 2rem;
        .input {
          background-color: #f5f5f5;
          border: 1px solid #00000033;
          padding: 0 1.3rem;
          border-radius: 1rem;
          display: flex;
          align-items: center;
          img {
            width: 3rem;
            height: 3rem;
            border-radius: 100%;
            object-fit: fill;
            background-color: rgb(216, 216, 216);
          }
          textarea {
            padding: 0.8rem 1.5rem;
            margin: 0.5rem 0;
            border: none;
            font-size: 1.6rem;
            font-family: $font-primary;
            box-shadow: none;
            outline: none;
            line-height: 2.2rem;
            color: $color-black;
            background-color: transparent;
            resize: none;
            width: 100%;
            &::placeholder {
              color: $color-placeholder;
            }
            &::-webkit-scrollbar {
              display: none;
            }
          }
          .buttons {
            display: flex;
            align-items: center;
            .disabled {
              opacity: 0.5;
              cursor: not-allowed;
            }
            .ant-btn {
              width: 5rem;
              background-color: $color-primary;
              border: none;
              outline: none;
              height: 3rem;
              color: $color-white;
              border-radius: 100px !important;
              padding: 0 !important;
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                line-height: normal;
              }
              .anticon {
                .anticon-spin {
                  font-size: 1.5rem;
                  color: $color-primary;
                }
              }
              &:hover,
              &:focus {
                background-color: $color-primary;
                color: $color-white;
              }
              .icon {
                font-size: 1.5rem !important;
                color: $color-white;
                line-height: normal;
              }
            }
          }
        }
      }
      .message {
        color: $color-black;
        font-size: 1.6rem;
        line-height: 2rem;
        font-family: $font-primary;
        text-align: center;
        margin: 2rem 0 0;
      }
      .discussion-card-skeleton {
        margin-bottom: 1.5rem;
        .ant-skeleton-header {
          height: 3rem;
          width: 3rem;
          border-radius: 100%;
          padding: 0;
          .ant-skeleton-avatar {
            height: 3rem;
            width: 3rem;
            border-radius: 100%;
          }
        }
        .ant-skeleton-content {
          padding-left: 1rem;
          .ant-skeleton-title {
            margin: 0.7rem 0 1rem;
            height: 1.5rem;
          }
          .ant-skeleton-paragraph {
            margin: 0;
            li {
              margin: 0 0 0.5rem;
            }
          }
        }
      }
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
      width: 0.4rem;
      height: 0.4rem;
    }
    &::-webkit-scrollbar {
      width: 0.4rem;
      height: 0.4rem;
      background-color: transparent;
      border-radius: 3rem;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 3rem;
    }
    &--chat-typing {
      display: flex;
      align-items: center;
      gap: 1rem;
      margin-bottom: 2rem;
      padding: 0 2rem 0 3.2rem;
      .user-images {
        display: flex;
        align-items: center;
        .image {
          width: 3rem;
          height: 3rem;
          border-radius: 100%;
          object-fit: fill;
          margin-left: -1.2rem;
          background-color: #f0f0f0;
        }
      }
      .dots {
        display: flex;
        align-items: center;
        gap: 0.3rem;
          span {
            display: block;
            width: 0.9rem;
            height: 0.9rem;
            background-color: #a0a0a0;
            border-radius: 50%;
            animation: typingAnimation 1.5s infinite ease-in-out;
          }
          span:nth-child(2) {
            animation-delay: 0.2s;
          }
          span:nth-child(3) {
            animation-delay: 0.4s;
          }
        }
    }
    @keyframes typingAnimation {
      0% { transform: translateY(0); opacity: 0.4; }
      50% { transform: translateY(-0.1rem); opacity: 1; }
      100% { transform: translateY(0); opacity: 0.4; }
    }
  }
  &__glocal-ai-body {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 36.2rem);
    padding-top: 1.8rem !important;
    .collaborate-container__body--search-bar {
      padding-top: 1.3rem;
      top: -1.8rem;
    }
  }
  &__footer {
    position: absolute;
    bottom: 0;
    width: calc(100% - 8rem);
    padding: 1.8rem 2rem;
    background-color: transparent;
    background-color: $color-white;
    width: 100%;
    border-end-start-radius: 2rem;
    border-end-end-radius: 2rem;
    &--comment {
      background-color: #F8F8F8;
      padding: 0 1.4rem;
      border-radius: 1rem;
      display: flex;
      align-items: center;
      margin: 0 auto;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 100%;
        object-fit: fill;
        margin-right: 1.5rem;
      }
      textarea {
        padding: 0.8rem 1.5rem 0.8rem 0rem;
        margin: 0.5rem 0;
        border: none;
        font-size: 1.6rem;
        font-family: $font-primary;
        box-shadow: none;
        outline: none;
        line-height: 2.2rem;
        color: $color-black;
        background-color: transparent;
        resize: none;
        width: 100%;
        &::placeholder {
          color: $color-placeholder;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .buttons {
        display: flex;
        align-items: center;
        .disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .ant-btn {
          width: 5rem;
          background-color: $color-primary;
          border: none;
          outline: none;
          height: 3rem;
          color: $color-white;
          border-radius: 100px !important;
          padding: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            line-height: normal;
          }
          .anticon {
            .anticon-spin {
              font-size: 1.5rem !important;
              color: $color-primary;
            }
          }
          &:hover,
          &:focus {
            background-color: $color-primary;
            color: $color-white;
          }
          .icon {
            font-size: 1.5rem;
            display: block;
            color: $color-white;
            line-height: normal;
          }
        }
      }
      .ai-comment-buttons {
        margin-top: auto;
        margin-bottom: 1.3rem;
      }
    }
    // &--glocal-ai-comment {
    //   img {
    //     width: 4rem;
    //     height: 4rem;
    //   }
    // }
  }
}
.collaborate-container-ai {
  .collaborate-container__glocal-ai-body {
    height: calc(100vh - 44rem) !important;
    padding-top: 0 !important;
  }
  .collaborate-container__body {
    height: calc(100vh - 39rem);
  }
}
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.ant-calendar-picker-container {
  overflow-x: auto;
  overflow-y: hidden;
  .ant-calendar-range {
    width: 64rem;
    overflow: hidden;
    margin: 1rem;
    background-color: $color-white;
    border-radius: 0.5rem;
  }
  @media (max-width: 400px) {
    width: 100%;
  }
}
</style>
